module.exports = __webpack_public_path__ + "img/softwcopr3.158a95c8.png";